import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { GlobalStore } from '../../store';
import User from '../../models/User';
import QueueEntry from '../../models/QueueEntry';
import QueueEntryRowViewComponent from './QueueEntryRow';
import { sortWithBookingPromotion } from '../../utils/queueSort';

export default (props: any): JSX.Element => {

  const user = useSelector<GlobalStore, User | null>(store => store.user);

  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 15_000);
    return () => clearInterval(id);
  }, []);

  const queueName: string = props.queueName;
  const queueEntries: QueueEntry[] = props.queueEntries;
  const filter: string = props.filter;
  const showHelperToAssistants: boolean = props.showHelperToAssistants;
  const onHelpStarted: (() => void) | undefined = props.onHelpStarted;

  const helperNames = queueEntries.filter(e => e.helper).map(e => e.helper);

  function filterUsers(entry: QueueEntry) {
    const lowerCaseFilter = filter.toLowerCase();

    const helpType = entry.help ? 'help' : 'presentation';

    return (
      filter === ''
      || entry.comment.toLowerCase().includes(lowerCaseFilter)
      || entry.location.toLowerCase().includes(lowerCaseFilter)
      || entry.realname.toLowerCase().includes(lowerCaseFilter)
      || helpType.includes(lowerCaseFilter));
  }

  return (
    <div className="row pr-lg-0">
      {
        queueEntries.length === 0
          ? <h3>This queue is empty</h3>
          : <table className="table table-hover table-striped table-responsive-sm">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  { user === null ? null : <th scope="col">User</th> }
                  <th scope="col">Location</th>
                  <th scope="col"></th>
                  <th scope="col">Comment</th>
                </tr>
              </thead>
              <tbody>
                {
                  sortWithBookingPromotion(queueEntries).filter(filterUsers).map((queueEntry, index) =>
                    <QueueEntryRowViewComponent
                      key={queueEntry.providerId}
                      index={index}
                      queueEntry={queueEntry}
                      queueName={queueName}
                      showHelperToAssistants={showHelperToAssistants}
                      onHelpStarted={onHelpStarted}
                      helperNames={helperNames} />)
                }
              </tbody>
            </table>
      }
    </div>
  );
};
